import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HospitalLanguageService } from 'src/app/core/i18n/hospital-language.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * アラート情報
 */
export interface PatientInfo {
  /**
   * 患者ID
   */
  id: string;
  /**
   * 患者名
   */
  name: string;
  /**
   * 診療科ID
   */
  departmentId: string;
  /**
   * 診療科名
   */
  departmentName: string;
  /**
   * 電池残量
   */
  battery: number;
  /**
   * 経過時間
   */
  elapsedTime: string;
  /**
   * 測定日時
   */
  measurementTime: string;
  /**
   * 経過表が記入されているか
   */
  isFilled: boolean;
  /**
   * バイタルサインデータ
   */
  data: string[];
  /**
   * 病室情報
  */
  roomInfo: string;
   
}

export interface VitalIconItem {
  iconPath: string;
  iconName: string;
}

@Component({
  selector: 'app-patient-card',
  templateUrl: './patient-card.component.html',
  styleUrls: ['./patient-card.component.css']
})
export class PatientCardComponent implements OnInit {

  @Input()
  infos: PatientInfo[] = [];

  // 経過表のボタンベント
  @Output() 
  surveyClicked = new EventEmitter<PatientInfo>();

  // 履歴のボタンベント
  @Output()
  historyClicked = new EventEmitter<PatientInfo>();

  iconItems: VitalIconItem[] = [
    {
      iconPath: 'assets/images/icon/time-icon.svg',
      iconName: 'time-icon'
    },
    {
      iconPath: 'assets/images/icon/blood-pressure.svg',
      iconName: 'blood-pressure-icon'
    },
    {
      iconPath: 'assets/images/icon/breath.svg',
      iconName: 'breath-icon'
    },
    {
      iconPath: 'assets/images/icon/heart-rate.svg',
      iconName: 'heart-rate-icon'
    },
    {
      iconPath: 'assets/images/icon/oxygen.svg',
      iconName: 'oxygen-icon'
    },
    {
      iconPath: 'assets/images/icon/sleep.svg',
      iconName: 'sleep-icon'
    },
    {
      iconPath: 'assets/images/icon/step.svg',
      iconName: 'step-icon'
    },
    {
      iconPath: 'assets/images/icon/temperature.svg',
      iconName: 'temperature-icon'
    },
    {
      iconPath: 'assets/images/icon/filled.svg',
      iconName: 'filled-icon'
    },
    {
      iconPath: 'assets/images/icon/not-filled.svg',
      iconName: 'not-filled-icon'
    },
    {
      iconPath: 'assets/images/icon/detail0.svg',
      iconName: 'detail-icon-0'
    },
    {
      iconPath: 'assets/images/icon/detail1.svg',
      iconName: 'detail-icon-1'
    },
    {
      iconPath: 'assets/images/icon/detail2.svg',
      iconName: 'detail-icon-2'
    },
    {
      iconPath: 'assets/images/icon/detail3.svg',
      iconName: 'detail-icon-3'
    },
    {
      iconPath: 'assets/images/icon/detail4.svg',
      iconName: 'detail-icon-4'
    },
  ];

  statuses = [
    {
      icon: 'heart-rate-icon',
      text: '拍/分',
    },
    {
      icon: 'temperature-icon',
      text: '℃',
    },
    {
      icon: 'blood-pressure-icon',
      text: 'mmHg',
    },
    {
      icon: 'breath-icon',
      text: '呼吸回数',
    },
    {
      icon: 'oxygen-icon',
      text: 'SpO2',
    },
    {
      icon: 'sleep-icon',
      text: '睡眠時間',
    },
    {
      icon: 'step-icon',
      text: '歩',
    },
  ];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private _cdr: ChangeDetectorRef,
    private hospLang: HospitalLanguageService,
  ) {
    // カスタムのsvgファイルをmat-iconとして使うため
    for (var iconItem of this.iconItems) {
      this.matIconRegistry.addSvgIcon(
        iconItem.iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(iconItem.iconPath)
      );
    }
  }

  ngOnInit(): void {
    this.statuses = this.statuses.map((s) =>
      s.text === '睡眠時間' ? { ...s, text: this.hospLang.t('睡眠時間') } : s,
    );
  }

  /**
   * バッテリー残量のアイコンを取得する
  */
  getBatteryIcon(battery: number): string {
    if (battery > 80) {
      return 'battery_full';
    } else if (battery > 60) {
      return 'battery_5_bar';
    } else if (battery > 40) {
      return 'battery_4_bar';
    } else if (battery > 20) {
      return 'battery_3_bar';
    } else {
      return 'battery_2_bar';
    }
  }

  getBackgroundColor(index: number): string {
    const colors = ['#F05E78', '#FDBD2F', '#7E8AE6', '#9FC700', '#58A0FD'];
    return colors[index % colors.length];
  }

  getDetailIcon(index: number): string {
    return `detail-icon-${index % 5}`;
  }

  /**
   * 経過表のボタンを押す
   */
  survey(info :PatientInfo): void {
    this.surveyClicked.emit(info);
  }

  /**
   * 履歴のボタンを押す
   */
  history(info: PatientInfo): void {
    this.historyClicked.emit(info);
  }

}
